import { render, staticRenderFns } from "./SVGUserTag.vue?vue&type=template&id=b889f930&scoped=true&"
import script from "./SVGUserTag.vue?vue&type=script&lang=js&"
export * from "./SVGUserTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b889f930",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b889f930')) {
      api.createRecord('b889f930', component.options)
    } else {
      api.reload('b889f930', component.options)
    }
    module.hot.accept("./SVGUserTag.vue?vue&type=template&id=b889f930&scoped=true&", function () {
      api.rerender('b889f930', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/SVG/SVGUserTag.vue"
export default component.exports